import { Handshake } from "lucide-react";

// Venue that came through a partner pipeline (Partnership / Channel partner) – always shown in amber
export const PartnerBadge = ({ label, className = "", testId }) =>
  label ? (
    <span
      data-testid={testId}
      title={`Partner-sourced venue · ${label} pipeline`}
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 border border-amber-300 px-1.5 py-px text-[10px] tv:text-[12px] font-bold uppercase tracking-wide whitespace-nowrap ${className}`}
    >
      <Handshake className="w-3 h-3 tv:w-[13px] tv:h-[13px]" /> Partner
    </span>
  ) : null;
